import React from 'react'
import CareerForm from '../components/CareersForm'

const CareerPage = () => {
  return (
    <>
        <CareerForm/>
    </>
  )
}

export default CareerPage